export default () => {
  // add spinner to checkout button when clicked if checkbox is checked
  const checkoutButton = document.querySelector('.js-loading-button');

  if (checkoutButton) {
    checkoutButton.addEventListener('click', (e) => {
      e.target.classList.add('button--loading');
    });
  }
};
